var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from "react";
import { Box, Drawer, List, styled, useMediaQuery, useTheme, ClickAwayListener, } from "@mui/material";
const RightDrawerWapper = styled("div")(({ theme }) => {
    return {};
});
export const RightDrawerComponent = (props) => {
    const { data } = props, rest = __rest(props, ["data"]);
    const theme = useTheme();
    const showText = useMediaQuery(theme.breakpoints.up("sm"));
    return (React.createElement(ClickAwayListener, { onClickAway: () => props.hideSideBar() },
        React.createElement(RightDrawerWapper, Object.assign({}, rest),
            React.createElement(Drawer, { anchor: "right", open: true, onClose: props.hideSideBar, transitionDuration: { enter: 400, exit: 400 }, style: showText
                    ? {
                        zIndex: 2,
                        marginTop: props.TopHeight,
                    }
                    : {} },
                React.createElement(Box, { sx: { maxWidth: "100vw", width: "26.4vw" }, style: showText ? { marginTop: props.TopHeight } : {} },
                    React.createElement(List, null, props.data))))));
};
